import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { figures } from "@/data/registry";
import { corrections } from "@/data/corrections";
import { FigureTile } from "@/components/figures/FigureTile";

const featuredIds = ["1", "6", "9", "16"];

export function StateOfTheSystemSection() {
  const featured = featuredIds
    .map((id) => figures.find((f) => f.id === id))
    .filter((f): f is NonNullable<typeof f> => Boolean(f));

  const published = corrections.filter((c) => c.status === "published");
  const latest = [...published].sort((a, b) =>
    b.date.localeCompare(a.date),
  )[0];

  return (
    <section className="border-t border-border/60 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-liberty-gold">
          State of the System
        </p>
        <h2 className="mt-3 font-display text-3xl font-bold text-foreground sm:text-4xl">
          What the record shows
        </h2>

        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {featured.map((figure) => (
            <FigureTile key={figure.id} figure={figure} />
          ))}
        </div>

        <Link
          to="/dashboard"
          className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-liberty-gold hover:opacity-80"
        >
          See the full dashboard <ArrowRight className="h-4 w-4" />
        </Link>

        <Link
          to="/corrections"
          className="mt-6 block rounded-lg border border-border/60 bg-card/40 px-4 py-3 text-[13px] text-muted-foreground transition-colors hover:border-liberty-gold/50"
        >
          Corrections published: {published.length}
          {latest ? ` · Latest: ${latest.title}` : ""}
        </Link>
      </div>
    </section>
  );
}
